import React,{useState, useEffect} from "react";
import BlockLoader from "../BlockLoader";
import { notifyError, notifyErrorInBottom } from "../../helper";
import client from '../../api';
import { useParams } from "react-router-dom";
import DataLoader from "../DataLoader";

const MessagePreview = (props) => {
    const {campaignID} =useParams('');
    const api = client();
    const messageType = props?.campaignPreview?.message_mime_type;
    const [blockLoader,setBlockLoader] = useState(true);
    const [payload, setPayload] = useState({campaign_id:campaignID,email:"",offset:0});
    const [messagePreviewData,setMessagePreviewData] = useState({});
    const [disablePrevious,setDisablePrevious] = useState(false);
    const [disabledNext,setDisabledNext] = useState(false);
    const [email,setEmail] = useState('');
    const [error,setError] = useState('');

    const getPreviousMessages = () => {
        if(payload.offset > 0){
        setBlockLoader(true);
        setMessagePreviewData({});

          setPayload({...payload,offset:(payload.offset-1)});
        }
        
    }
    const getNextMessages = () => {
        if(payload.offset < (messagePreviewData?.total - 1)){
            setBlockLoader(true);
            setMessagePreviewData({});
            setPayload({...payload,offset:(payload.offset+1)});
        }
    }
    const onBlur = (e) => {
        if(!(/\S+@\S+\.\S+/).test(e.target.value)){
            setError('Please enter a valid email');
        }
        
    }
    const onFocus = (e) => {
        setError(''); 
    }

    const clearEmailInput = () => {
        setEmail('');
        //Reset Payload
        setBlockLoader(true);
        setMessagePreviewData({});
        setPayload({campaign_id:campaignID,email:"",offset:0});
    }

    const getMessageDataByEmail = () => {
        if((/\S+@\S+\.\S+/).test(email)){
            setBlockLoader(true);
            setMessagePreviewData({});
            setPayload({...payload,email:email,offset:0});
        } else {
            setError('Please enter a valid email');
        } 
    }
    const enter = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            getMessageDataByEmail();
        }
    }
    useEffect(()=>{
        const getMessagePreviewOnebyOne = async() => {
            try{
                const response = await api.post('/v1/campaign/preview/messages',payload);
                if(response.status === 200 ||response.status === 201){
                    setMessagePreviewData(response.data.data);
                    setBlockLoader(false);
                }
            } catch (error) {
                setBlockLoader(false);
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Unable to fetch Campaign Message Preview. Please try again');
                if(error.status === 404) notifyErrorInBottom('No contact found to show the preview. Please check and try again');
                
            }
        }
        getMessagePreviewOnebyOne();
    },[payload]);
    
    return(<>
        <div className="edit-section">
            {/* <span className="edit-note">Edits are saved as your switch recipients or hits "Next"</span> */}
            <div className="verify-emails">
                <div className="left-side">
                    <div className="test-username-info">
                        {/* <span className="u-name">Tejaswi Sharma</span>  */}
                        <span  className="u-email">{messagePreviewData?.email}</span>
                    </div>
                    <div className="search-email-wrap">
                        <div className="search-input">
                            <input 
                                type="text" 
                                placeholder="Search Email" 
                                value={email} 
                                onChange={(e)=>{setEmail(e.target.value)}}
                                onKeyDown={e => enter(e)} 
                                onFocus={onFocus}
                                //onBlur={onBlur}
                                />
                            {email.length ? <span 
                            
                            className="close-it"
                            onClick={()=>{clearEmailInput()}}
                            >
                                <i className='bx bx-x'></i>
                            </span>:''}
                        </div>
                        <button onClick={()=>{getMessageDataByEmail()}}>
                            <i className='bx bx-search'></i>
                        </button>
                        {error.length ? <span className="validation-error white-bg">{error}</span> :''}
                    </div>
                </div>
                <div className="right-side">
                    <p className="total-recipient">{(1+messagePreviewData?.offset)} of {(messagePreviewData?.total)} Recipients</p>
                    <div className="btn-wrap">
                        <button 
                            className="prev" 
                            disabled={payload.offset === 0} 
                            onClick={()=>{
                                getPreviousMessages()
                            }}><i className='bx bx-chevron-left'></i></button>

                        <button 
                            className="next" 
                            disabled={(payload.offset === (messagePreviewData?.total - 1))}
                            onClick={()=>{
                                getNextMessages()
                            }}><i className='bx bx-chevron-right'></i></button>
                    </div>
                </div>
            </div> 
        </div>
        {!blockLoader ? (Object.keys(messagePreviewData).length ? <div className="preview-msg-block">
                <div className="email-steps">
                    <span><i className="bx bx-envelope"></i> Initial Campaign Email</span>
                </div>
            <div className="field-wrap">
                <label className="label-xs">Subject:</label>
                {messagePreviewData.hasOwnProperty('steps') && <input type="text" defaultValue={messagePreviewData?.steps[0].subject} readOnly />}
            </div>
            <div className="preview-message">
                <label className="label-xs">Message:</label>
                {messagePreviewData.hasOwnProperty('steps') && (messageType === 'text/plain' ? <pre className="pre-msj"><div className="message-box" dangerouslySetInnerHTML={{__html:messagePreviewData?.steps[0].body}}></div></pre>:<div className="message-box" dangerouslySetInnerHTML={{__html:messagePreviewData?.steps[0].body}}></div>)}
            </div> 
            {messagePreviewData.hasOwnProperty('steps') && <div className="preview-msg-block">
                {(messagePreviewData.steps).slice(1).map((message,i)=>(<div key={i} className={`follow-up-${++i}`}>
                    <div className="email-steps">
                        <span><i className="bx bx-envelope"></i> Follow-up {message.delay} {message.delay < 2 ? 'day':'days'} later</span>
                    </div>
                    <div className="field-wrap">
                        <label className="label-xs">Subject</label>
                        <input type="text" value={message.subject} readOnly />
                    </div>
                    <div className="preview-message">
                        <label className="label-xs">Message:</label>
                        {messageType === 'text/plain' ? <pre className="pre-msj"><div className="message-box" dangerouslySetInnerHTML={{__html:message.body}}></div></pre>:<div className="message-box" dangerouslySetInnerHTML={{__html:message.body}}></div>}
                    </div>
                </div>))}
            </div>}
        </div>:'This email does not exist'):<BlockLoader height={'300px'}/>}
    </>);
}

export default MessagePreview;